module.exports = __webpack_public_path__ + "img/js.ae60adf4.png";